import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 알람 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getLmsAlarmList(param) {
    return axios.post(`${baseUrl}/settings/lms-alarm/get-alarm-list.do`, param);
  },
  /**
   * 알람 선택에 따른 이벤트 목록 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getEventList(params) {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-event-list.do`, { params });
  },
  /**
   * 수신자 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getUserList() {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-user-list.do`);
  },
  /**
   * 저장소 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getDataIndex() {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-data-index.do`);
  },
  /**
   * 저장소 구성 필드 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDataIndexField(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/get-data-index-field.do`, params);
  },
  /**
   * 알람 설정 시 사용할 이벤트 레벨 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getEventlevel() {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-event-level.do`);
  },
  /**
   * 알람 추가
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertLmsAlarm(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/insert-lms-alarm.do`, params);
  },
  /**
   * 알람 수신여부를 포함한 수신자 리스트
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getApplyReciverList(params) {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-apply-reciver-list.do`, { params });
  },
  /**
   * 알람 설정 시 패턴 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getAlarmPatternList(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/get-alarm-pattern-list.do`, params);
  },
  /**
   * 알람 설정 시 필터 목록 조회
   * @author leesy918
   * @return {[type]} [description]
   */
  getAlarmBaseline() {
    return axios.get(`${baseUrl}/settings/lms-alarm/get-alarm-baseline.do`);
  },
  /**
   * 콤보박스에서 선택한 필터의 정보 조회
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAlarmFilterInfo(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/get-filter-info.do`, params);
  },
  /**
   * 알람 삭제
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteLmsAlarm(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/delete-lms-alarm.do`, params);
  },
  /**
   * 알람 설정 수정
   * @author leesy918
   * @param  {[type]} queryString [description]
   * @param  {[type]} params      [description]
   * @return {[type]}             [description]
   */
  updateEventSet(queryString, params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/update-event-set.do?${queryString}`, params);
  },
  /**
   * 알람 목록에서 저장버튼 클릭 시 작동
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateAlarmList(params) {
    return axios.post(`${baseUrl}/settings/lms-alarm/update-alarm-list.do`, params);
  },
  /**
   * 저장소 또는 미확인 패턴 타입으로 알람 추가 시 이미 해당 타입의 알람이 존재하는지 확인
   * @author Minyeong
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkEventType(params) {
    return axios.get(`${baseUrl}/settings/lms-alarm/check-event-type.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/log/lms-alarm-setting.js